// Utility for validating money input fields
// - Required (if required flag is true)
// - Numeric (if not empty)
// - Optional min value
// - Max 7 digits before decimal, max 2 after
export function validateMoney(required: boolean, value: any, min?: number) {
  if ((value === undefined || value === null || value === '') && required) return 'This field is required'
  if (value === undefined || value === null || value === '') return true
  // Accept both string and number
  const num = Number(value)
  if (isNaN(num)) return 'Please enter a valid number'
  if (min !== undefined && num < min) return `Amount must be at least $${min}`
  // Regex: up to 7 digits before decimal, optional decimal, up to 2 digits after
  // Accepts: 1234567, 1234567.89, 1.23, but not 12345678, 1234567.891
  const moneyPattern = /^\d{1,7}(\.\d{1,2})?$/
  if (!moneyPattern.test(String(value))) {
    return 'Enter max 7 digits before decimal and max 2 after (e.g. 1234567.89)'
  }
  return true
}
